import Head from "next/head";

import { twMerge } from "tailwind-merge";

import TopNavBar from "components/TopNavBar";
import { emberAppBaseUrl } from "utils/envVariables";

import style from "./404/style.module.scss";

type Page500Props = {
  header?: string;
  message?: string;
  statusCode?: number;
};

const Page500 = ({ header, message, statusCode }: Page500Props) => {
  return (
    <div>
      <Head>
        <title>{statusCode || 500}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <div className={style.container}>
        <TopNavBar />
        <div className={style.content}>
          <div className={twMerge(style.text, "mb-[15px]")}>
            <h1 className="text-shady-gray font-light text-[33px] my-[15px]">
              {header || "Oops…"}
            </h1>
            <div className="bg-white rounded-lg shadow-lg flex">
              <div className="w-[47px] rounded-l bg-bearish-red text-white text-[45px] flex items-center justify-center">
                <div>!</div>
              </div>
              <div className="p-[15px] w-[320px] text-left">
                {message || "Oops! Something went wrong. Please try again."}
              </div>
            </div>
          </div>
          <div className={style.more}>
            <ul className={style.links}>
              <li className={style.links_item}>
                <a
                  href={`${emberAppBaseUrl}/dashboard`}
                  className={style.links_btn}
                >
                  Dashboard
                </a>
              </li>
              <li className={style.links_item}>
                <button
                  className={style.links_btn}
                  onClick={() => history.back()}
                >
                  Back
                </button>
              </li>
              <li className={style.links_item}>
                <a
                  href="mailto:tech@smartkarma.com?subject=404"
                  className={style.links_btn}
                >
                  Report Issue
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page500;
